export default __webpack_public_path__ + "static/media/edit.3142c31b.svg";